<template>
	<div>
		<citrus-product-basket-price
			v-if="showPrice"
			:base-price="price.full"
			:discount-price="price.price"
			:class="priceClass"
		></citrus-product-basket-price>
		<slot></slot>
		<citrus-product-basket-quantity
			v-if="inBasket"
			:quantity="quantityBasket"
			:class="'b-counter_catalog ' + quantityClass"
			:measure="measure"
			:max-quantity="maxQuantity"
			:id="productId"
			@change="changeQuantity"
		></citrus-product-basket-quantity>
		<citrus-product-basket-button
			v-else
			:metric-goal="metricGoal"
			:block-class="buttonClass"
			:quantity="parseFloat(quantityToAdd)"
			:product-id="productId"
			:price="price"
			:detail-url="detailUrl"
			:basket-url="basketUrl"
			:has-sku="hasSku"
			:show-mobile="showMobile"
			:storage-type="storageType"
			:bind-global-basket="true"
			:custom-text="customText"
		></citrus-product-basket-button>
	</div>
</template>
<script>
	export default {
		name: "ButtonWithQuantity",
		props: {
			measure: {
				type: Object,
				default: function () {
					return {
						id: 0,
						name: "",
						value: 1,
						ratio: 1,
					}
				}
			},
			maxQuantity: {
				type: Number,
				default: 9999
			},
			buttonClass: {
				type: String,
				default: ''
			},
			quantityClass: {
				type: String,
				default: ''
			},
			priceClass: {
				type: String,
				default: 'b-price_productCard'
			},
			showPrice: {
				type: Boolean,
				default: false
			},
			metricGoal: {
				type: [Boolean, String],
				default: false
			}
		},
		data: function () {
			return {
				priceData: {},
				quantityToAdd: this.measure.ratio,
			};
		},
		computed: {
			/**
			 * Лежит ли товар в корзине
			 *
			 * @return {Boolean}
			 */
			inBasket() {
				let inBasket = false;
				switch (this.storageType) {
					case 'vuex':
						inBasket = this.$store.getters['basket/check'](this.productId);
						break;
					case 'input':
						inBasket = true === this.price.in_basket;
						break;
					default:
						inBasket = false;
				}

				return inBasket;
			},
			quantityBasket() {
				return this.$store.getters['basket/quantity'](this.productId);
			},
		},
		methods: {
			changeQuantity: function (params) {
				this.$store.dispatch("basket/change", params);
			},
		},
	}
</script>